export default {
    config: {
        defaultWidth: 80
    },
    default: {
        label: 'Win %'
    },
    unique: [],
    sort: 'plays.winpercent',
    lang: {
        name: 'Win Percent',
        category: ['User', 'Plays'],
        description: 'Win percentage for plays of a game.',
        views: ['list', 'sheet', 'grid'],
        contexts: ['collection', 'ratings', 'gameplays'],
    },
    filters: [],
    types: ['user']
}